export default {
    // searchTitle: '投放平台',
    searchMode: "group",
    rowSelection: false,
    fieldControl: true,
    columns: [
      {
        title: '应用key',
        dataIndex: 'platformCode',
        width: 100,
        fixed: 'left',
      },
      {
        title: '应用名称',
        dataIndex: 'platformName',
        width: 200,
      },
      {
        title: '投放平台',
        dataIndex: 'platformTypes',
        width: 150,
        render: 'platformTypesRender',
      },
      // {
      //   title: '允许授权',
      //   dataIndex: 'allowAuth',
      //   width: 120,
      //   render: (allowAuth: boolean) => (allowAuth ? '允许' : '禁用'),
      // },
      // {
      //   title: '授权链接模板',
      //   dataIndex: 'authUrlTemplate',
      //   width: 300,
      //   ellipsis: {
      //     overlayStyle: {
      //       maxHeight: 360,
      //     },
      //   },
      // },
      // {
      //   title: '最后修改人',
      //   dataIndex: 'modifiedBy',
      //   width: 140,
      // },
      {
        title: '创建时间',
        dataIndex: 'lastUpdatedTime',
        itemType: 'date',
        width: 120,
        render: 'datetimeRender',
      },
      {
        title: '操作',
        dataIndex: 'actionTool',
        width: 140,
        render: 'actionTool',
        fixed: 'right',
      },
    ],
    search: [
      {
        name: 'platformCode',
        label: '应用key',
        itemType: 'input',
        placeholder: '请输入应用key',
      },
      {
        name: 'platformNameKeyword',
        label: '应用名称',
        itemType: 'input',
        placeholder: '请输入应用名称',
      },
      {
        name: 'platformType',
        label: '投放平台',
        itemType: 'select',
        key: 'key',
        labelKey: 'value',
        data: 'platformTypes',
      },
    ],
    footer: [
      {
        label: '新增',
        type: 'primary',
        events: ['onClick:onAdd'],
      },
    ],
  };
  